module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "issues-list-preview.6b7c6e1a.png";